import { createFileRoute } from '@tanstack/react-router'

import CoverageSheetContent from '@/components/sheets/coverage/coverage-sheet-content'

export const Route = createFileRoute(
  '/app/data/companies/$uuid/(mainPage)/insured/insistences/$coverageUuid/',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { coverageUuid } = Route.useParams()

  return <CoverageSheetContent coverageUuid={coverageUuid} />
}
